// English and Hebrew text objects
export type Lang = 'he' | 'en';
export type Texts = {
    header: string;
    donationLink: string;
    headerBold: string;
    chooseDonationType: string;
    oneTime: string;
    recurring: string;
    chooseAmount: string;
    otherAmount: string;
    total: string;
    personalDetails: string;
    fullName: string;
    phone: string;
    email: string;
    settlement: string;
    marketing: string;
    next: string;
    confirm: string;
    ourFights: string;
    box1Title: string;
    box1Text: string;
    box2Title: string;
    box2Text: string;
    box3Title: string;
    box3Text: string;
    box4Title: string;
    box4Text: string;
    donation50INS: string;
    donation100INS: string;
    donation300INS: string;
    donation500INS: string;
    donation1000INS: string;
    donation2000INS: string;
  };
  /*
  *אחים.יות לנשק*
*תמיד בחזית*

בימים שבהם הדמוקרטיה הישראלית עומדת למבחן אנחנו — אחים ואחיות לנשק — לא ננוח לרגע. המתנגדים בהפיכה המשטרית, דרך המלחמה בעוינות המתמשכת ופגיעות בצה״ל, ועד למאבק המתמשך לשוויון ושותפות — אנחנו תמיד בחזית.

כככדישנוכל להמשיך — אנחנו צריכים אותך איתנו. התרומה שלך מהותית להיכולת שלנו לפעול. יחד נשמור על הדמוקרטיה!
*/
  export const texts: Record<Lang, Texts> = {
    he: {
      header: 'בימים שבהם הדמוקרטיה הישראלית עומדת למבחן אנחנו — אחים ואחיות לנשק - לא נעצור לרגע. \n\nבלמנו את ההפיכה המשטרית. הצלנו את המדינה ב-7 באוקטובר. עכשיו נעמוד כחזית אזרחית אחת כדי שיוכלו כל אזרחי המדינה לממש את זכותם הדמוקרטית בבחירות הקרובות. \n',
      donationLink: '',
      headerBold: 'אנחנו צריכים את תרומתך. יחד נשמור על הדמוקרטיה.',
      chooseDonationType: 'בחרו סוג תרומה:',
      oneTime: 'חד פעמית',
      recurring: 'חודשית',
      chooseAmount: 'איזה סכום תרצו לתרום?',
      otherAmount: 'סכום אחר',
      total: 'סך הכל לתרומה:',
      personalDetails: 'פרטים אישיים',
      fullName: 'שם מלא *',
      phone: 'טלפון *',
      email: 'אימייל *',
      settlement: 'ישוב *',
      marketing: 'אני מאשר.ת שליחות עידכונים מאחים לנשק *',
      next: 'הבא',
      confirm: 'בלחיצה על  כפתור ״תשלום״ אני מאשר שקראתי את תנאי השימוש ואת מדיניות הפרטיות',
      ourFights: 'המאבקים שלנו',
      box1Title: 'נאבקים בהפיכה המשטרית',
      box1Text: 'המאבק שלנו החל כהתנגדות למהלכים שנועדו לערער את מערכת האיזונים והבלמים של הדמוקרטיה הישראלית. כאשר הממשלה מנסה לפגוע בעצמאות בתי המשפט ולהחליש את שומרי הסף, אנחנו שם - עומדים איתנים ושומרים על ערכי הדמוקרטיה הישראלית.',
      box2Title: 'נאבקים בקומבינת ההשתמטות',
      box2Text: 'צבא העם הוא ערך מכונן בחברה הישראלית. אנו נאבקים בניסיונות לקדם את קומבינת ההשתמטות ולתת פטור גורף לעשרות אלפי צעירים חרדים משירות צבאי, במיוחד בתקופה קריטית שבה צה"ל זקוק לכל לוחם אפשרי. אנחנו נאבקים ברחובות, בבגצ, בוועדות הרלוונטיות בכנסת, בשיחות עם המפלגות וחברי הכנסת מהקשת הרחבה של החברה הישראלית ובהפגנות מול סמלי ההפקרה.',
      box3Title: 'שומרים על שומרי הסף',
      box3Text: 'כאשר הממשלה מפטרת את ראש השב"כ בעיצומה של חקירת פרשת קטארגייט והקשר בין יועצי ראש הממשלה עם מממני הטרור, אנחנו מתייצבים להגנת שומרי הסף. נאמנותם של שומרי הסף היא לעם ולממלכה, לא לפוליטיקאים. אתם איתנו ברחובות, בוובינרים להעלאת המודעות להשלכות המסוכנות שבהחלשתם, בחוגי בית, מפגשים עם בני ובנות מכינות, בקמפיינים דיגיטליים ובשלטי חוצות ברחבי ישראל.',
      box4Title: 'פועלים להשבת החטופים',
      box4Text: 'מאז 7 באוקטובר, אנחנו פועלים ללא הפסקה להשבת החטופים. כשהממשלה מחליטה מסיבות פוליטיות לחבל בעסקה להשבת החטופים, אנחנו מתריעים ומזכירים: החטופים הם האחים והאחיות של כולנו ולא נעצור את המאבק עד שובם של כולם הביתה!',
      donation50INS: '₪50',
      donation100INS: '₪100',
      donation300INS: '₪300',
      donation500INS: '₪500',
      donation1000INS: '₪1000',
      donation2000INS: '₪2000',
    },
    en: {
      header: "Votre soutien est essentiel. Pour faire un don par carte bancaire, veuillez sélectionner l’un des montants\n prédéfinis ci-dessous ou saisir le montant de votre choix\n dans le champ libre.\n (Le total s’affichera automatiquement en shekels une fois le montant sélectionné.)\n\n Si vous préférez effectuer un virement bancaire, veuillez cliquer sur le\n drapeau de l’UE au lien ",
      donationLink: "https://www.bnsia.org/en/donate/",
      headerBold: "",
      chooseDonationType: 'Choose donation type:',
      oneTime: 'One-time',
      recurring: 'Monthly',
      chooseAmount: 'How much would you like to donate?',
      otherAmount: 'Other amount',
      total: 'Total donation:',
      personalDetails: 'Personal Details',
      fullName: 'Full Name *',
      phone: 'Phone *',
      email: 'Email *',
      settlement: 'Settlement *',
      marketing: 'I agree to receive updates from Brothers in Arms *',
      next: 'Next',
      confirm: 'By clicking the "Pay" button, I confirm that I have read the Terms of Use and Privacy Policy',
      ourFights: 'Our Fights',
      box1Title: 'Fighting the Judicial Coup',
      box1Text: 'Our struggle began as opposition to moves intended to undermine the checks and balances of Israeli democracy. When the government tries to harm the independence of the courts and weaken the gatekeepers, we stand firm and protect the values of Israeli democracy.',
      box2Title: 'Fighting Draft Evasion',
      box2Text: 'The people’s army is a foundational value in Israeli society. We fight attempts to promote mass draft evasion and grant blanket exemptions to tens of thousands of Haredi youth from military service, especially at a critical time when the IDF needs every possible fighter. We fight in the streets, in the High Court, in relevant Knesset committees, in talks with parties and MKs from across Israeli society, and in demonstrations against symbols of abandonment.',
      box3Title: 'Protecting the Gatekeepers',
      box3Text: 'When the government fires the head of the Shin Bet in the midst of the Qatargate investigation and the connection between the Prime Minister’s advisors and terror financiers, we stand up to defend the gatekeepers. Their loyalty is to the people and the state, not to politicians. You join us in the streets, in webinars raising awareness of the dangers of weakening them, in home meetings, encounters with pre-army students, digital campaigns, and billboards across Israel.',
      box4Title: 'Working for the Return of the Hostages',
      box4Text: 'Since October 7th, we have been working tirelessly for the return of the hostages. When the government, for political reasons, sabotages a deal to bring the hostages home, we sound the alarm and remind everyone: the hostages are our brothers and sisters, and we will not stop fighting until they are all home!',
      donation50INS: '€13',
      donation100INS: '€26',
      donation300INS: '€78',
      donation500INS: '€130',
      donation1000INS: '€260',
      donation2000INS: '€520',
    }
  };
  